import Department from './modules/Department';
import Execution from './modules/Execution';
import LocalExecution from './modules/LocalExecution';
import Category from './modules/Category'

const modules = {
  Department,
  Execution,
  LocalExecution,
  Category
};

export default modules;